import { ProductTypeWithIdAndPrice } from '@/types';
import { getProductTypePrice } from '@/model/pricing/getProductTypePrice';
import { StoreState } from '@/redux/types';

export const selectProductTypePrice =
  (productType: ProductTypeWithIdAndPrice, quantity?: number) => (state: StoreState) =>
    getProductTypePrice(state, productType, quantity);
